export default __webpack_public_path__ + "static/media/houimg2.d130e458.webp";